<template>
  <div>
    <v-app class="p-4">
      <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
        <div class="mt-5 pt-5">
          <data-table
              :data="data"
              :columns="columns"
              :debounce-delay="3000"
              :translate="translate"
              :per-page="[10, 25, 50, 100, 500]"
              :orderBy="tableProps.column"
              :pagination="paginate"
              :orderDir="tableProps.dir"
              @on-table-props-changed="reloadTable"
              :loading="true"
             class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
          >
          </data-table>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import {dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {debounce} from "../../../custom";

export default {
  name: "divarNews",
  components: {TitleRibbon},
  data() {
    return {
      dialog: false,
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      groupModal: false,
      chargeMount: '',
      classes: {
        table: 'table table-striped table-bordered table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs text-center',
      },
      numbersInfo: false,
      selectedNumber: [],

      dataId: '',
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          transform: (val) => {
            return `<input type="checkbox"  data-id="${val.data.phone}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          searchable: true,
        },
        {
          label: 'کاربر',
          name: 'phone',
          orderable: true,
          searchable: true,
        },
        {
          label: 'نام مستعار',
          name: 'nick_name',
          transform: (val) => {
            return val.data.nick_name ? val.data.nick_name : 'وجود ندارد';
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'کلمه کلیدی',
          name: 'balance',
          transform: (val) => {
            return val.data.balance ? val.data.balance : '-';
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'شهر',
          name: 'is_round',
          transform: (val) => {
            return val.data.is_round ? 'دارد' : 'ندارد'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'نام دسته',
          name: 'can_divert',
          transform: (val) => {
            return val.data.can_divert ? 'دارد' : 'ندارد'
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'زمان ایجاد',
          name: 'created_at_diff',
          orderable: true,
        },
        {
          label: 'آخرین فعالیت',
          name: 'created_at_diff',
          orderable: true,
        },
        {
          label: 'تعداد ارسال شده',
          name: 'created_at_diff',
          orderable: true,
        }
      ],
      data: {},
      url: `${url}/number`,
    }
  },
  methods: {
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this
      $.ajax({
          url: url,
          fn: this.getDataForTable,
          type: 'GET',
          data: query,
          headers: {
              "ACCEPT": "application/json",
              "Authorization": Token
          },
          success: function (data) {
              vm.data = data
          }
      })
    },
    reloadTable(tableProps) {
        debounce(()=>{
            this.getDataForTable(this.url, tableProps);
        }, 700);
    },
    actions(data, type) {
    },
  },
  mounted() {
    this.getDataForTable(this.url)

    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedNumber = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedNumber = []
      }
    })
  },
}
</script>

<style scoped>

</style>